/**
 * containerStyle: Basic combo's container style    object
 * optionStyle: Basic combo's option style    object
 * combos: Basic combo's item list    array
 *     ex) [
				{
					value: "",
					name: "선택해주세요.",
					disabled: true,
					selected: true,
				},
				{ value: "java", name: "자바" },
				{ value: "javaScript", name: "자바스크립트" },
			]
 * value: Basic combo's value    state
 * onChange: Basic combo's onChange    function
 * 
 */

import React from "react";

function BasicCombo({
  wrapClass = "input_set",
  containerClass = "combo_container",
  containerStyle,
  optionsClass = "combo_option",
  optionStyle,
  name,
  combos = [],
  value = "",
  onChange,
  style,
}) {
  const ComboChange = (e) => {
    onChange(e.target.value);
  };
  return (
    <div className={wrapClass}>
      <div>{name ? <label style={style}>{name}</label> : null}</div>
      <select
        className={containerClass}
        style={containerStyle}
        onChange={ComboChange}
        value={value}
        required
      >
        {combos.map((item, index) => {
          return (
            <option
              className={optionsClass}
              style={optionStyle}
              key={index}
              value={item.value}
              disabled={item.disabled}
            >
              {item.name}
            </option>
          );
        })}
      </select>
    </div>
  );
}

BasicCombo.defaultProps = {};

export default BasicCombo;
